import { PurchasePersistenceModel } from '@/core/domain/purchase-persistence/models/PurchasePersistence.model';
import { GetPurchaseUseCase } from '@/core/domain/purchase-persistence/usecases/get-purchase-persistence.usecase';
import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'vg-card-giftcard-ready',
    templateUrl: './card-giftcard-ready.component.html',
    styleUrls: ['./card-giftcard-ready.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CardGiftcardReadyComponent {
    @Input() card: any;
    public purchasePersistence: PurchasePersistenceModel | null = null;
    constructor(private readonly getPurchasePersistence: GetPurchaseUseCase) {
        this.initPurchasePersistence();
    }
    public initPurchasePersistence(): void {
        this.getPurchasePersistence
            .execute()
            .subscribe((purchasePersistence) => {
                this.purchasePersistence = purchasePersistence;
            });
    }
}
